import { render, staticRenderFns } from "./StudentTutorialView.vue?vue&type=template&id=288e492a&scoped=true&"
import script from "./StudentTutorialView.vue?vue&type=script&lang=js&"
export * from "./StudentTutorialView.vue?vue&type=script&lang=js&"
import style0 from "./StudentTutorialView.vue?vue&type=style&index=0&id=288e492a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e492a",
  null
  
)

export default component.exports